import { render } from "./fittingEqument.vue?vue&type=template&id=f002b52a&scoped=true"
import script from "./fittingEqument.vue?vue&type=script&lang=js"
export * from "./fittingEqument.vue?vue&type=script&lang=js"

import "./fittingEqument.vue?vue&type=style&index=0&id=f002b52a&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f002b52a"]])

export default __exports__